export const deleteFromWaiting = (id: number, page: number) => ({
  type: "@saga/DELETE_FROM_WAITING",
  payload: { id, page },
});
